import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.compressimages.org';
const DEFAULT_IMAGE = `${SITE_URL}/android-chrome-512x512.png`;
const DEFAULT_LOGO = `${SITE_URL}/logo.svg`;

const Seo = ({
  title,
  description,
  path = '/',
  type = 'website',
  image = DEFAULT_IMAGE,
  jsonLd,
}) => {
  const canonicalUrl = `${SITE_URL}${path}`;
  const fullTitle = title.includes('CompressImages.org')
    ? title
    : `${title} | CompressImages.org`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="CompressImages.org" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export { SITE_URL, DEFAULT_IMAGE, DEFAULT_LOGO };
export default Seo;
